// 把utils文件夹下的所有文件都注册到Vue里
export default {
    install(Vue, options) {
        Vue.prototype.$utils = {}
        const files = require.context('.', false, /\.js$/)
        files.keys().forEach(key => {
            if (key === './index.js') return
            Vue.use(files(key).default)
        })
    }
}